import { PublicClientApplication } from "@azure/msal-browser";

///------API URLS-----------
// export const BASE_URL = "https://gambera-rms-api.azurewebsites.net";
export const BASE_URL = "https://gd-rms-api.azurewebsites.net";
// export const BASE_URL = "https://gd-rms-test-api.azurewebsites.net";
// export const BASE_URL = "https://localhost:7187";
// export const BASE_URL = "https://localhost:7251";
// export const BASE_FUN_URL = "http://localhost:7055";
///------API URLS-----------

///------FUNCTION URLS-----------
export const BASE_FUN_URL = "https://gd-rms-fn.azurewebsites.net";
// export const BASE_FUN_URL = "https://gd-rms-fn-test.azurewebsites.net";
///------FUNCTION URLS-----------

///------STORAGE URLS-----------
export const BASE_FILE_URL =
  "https://gamberadynamics.blob.core.windows.net/image";
///------STORAGE URLS-----------

///------CHATBOT API URLS-----------
// export const BASE_CHAT_URL='http://127.0.0.1:3001'
// export const BASE_CHAT_URL =
//   "https://appolo-agent-ai-bkdyd7hpdecdfrax.westeurope-01.azurewebsites.net";
export const BASE_CHAT_URL =
  "https://appolo-agent-ai-bkdyd7hpdecdfrax.westeurope-01.azurewebsites.net";
// export const BASE_CHAT_URL = "http://localhost:8080";
// export const BASE_CHAT_URL = "http://localhost:3001";
///------CHATBOT API URLS-----------

export const Client_id =
  "875838615965-k4ui5vc23fdtgjaa5nvg4er82h2a3pe1.apps.googleusercontent.com";
export const AlphaVersion = "1.0.8";
export const userRole = [
  { name: "Super-Admin", id: 100 },
  { name: "Admin", id: 200 },
  { name: "Operator", id: 300 },
];

//microsoft Instance
const msalConfig = {
  auth: {
    clientId: "10608ece-ac47-4208-b5ba-383d88675041",
    authority:
      "https://login.microsoftonline.com/bef898b5-25e5-4796-93ab-11f861b61208",
    // redirectUri: "http://localhost:3000",
    redirectUri: "https://gd-rms-dev.azurewebsites.net",
    // redirectUri: "https://gd-rms-test.azurewebsites.net",
  },
  // Additional configuration as needed
};

const msalInstance = new PublicClientApplication(msalConfig);
export default msalInstance;

export const Severities = [
  {
    id: 1,
    label: "Critical",
    value: "critical",
    icon: "critical-icon.svg",
    color: "border-red-600",
    bgColor: "red-600",
  },
  {
    id: 2,
    label: "Warning",
    value: "warning",
    icon: "warning-icon.svg",
    color: "border-amber-500",
    bgColor: "amber-500",
  },
  {
    id: 3,
    label: "Info",
    value: "info",
    icon: "info-icon.svg",
    color: "border-yellow-400",
    bgColor: "yellow-400",
  },
];

export const alarmStatuses = [
  {
    id: 2,
    label: "Open",
    value: "open",
    icon: "Eye-icon.svg",
    tooltip: "openAlrms",
  },
  {
    id: 1,
    label: "Acknowledged",
    value: "acknowledged",
    icon: "Acknowledge-icon.svg",
    tooltip: "acknowledgedAlrms",
  },
  {
    id: 3,
    label: "Closed",
    value: "closed",
    icon: "clear-icon.svg",
    tooltip: "closedAlrms",
  },
];

export const operators = ["=", ">", "<"];

export const speed = [1, 5, 10, 20, 50];

export const userRole2 = [
  // { name: "Super-Admin", id: 100 },
  { name: "Admin", id: 200 },
  { name: "Operator", id: 300 },
];

export const intervalData = [30, 60, 90];

export const timeModes = [
  { id: 24, name: "24 hrs." },
  { id: 12, name: "12 hrs." },
  { id: 6, name: "6 hrs." },
];

export const typeData = ["String", "Number", "Boolean", "GeoLocation"];

export const graphTypeData = [
  { id: "line", name: "Line" },
  { id: "area", name: "Area" },
  { id: "column", name: "Column" },
  { id: "pie", name: "Pie" },
];

export const typeData2 = [
  { id: 100, name: "String" },
  { id: 200, name: "Number" },
  { id: 300, name: "Boolean" },
  { id: 400, name: "GeoLocation" },
];

export const unitData = ["", "°C", "°F", "%", "mV", "km/h", "Lts", "km"];

export const simType = [
  { id: 100, value: "Single" },
  { id: 200, value: "Dual" },
];

export const valueOptionSensorIds = ["GSM", "GNSS", "Device Status"];

export const rangeOption = [
  { id: 100, value: "Show Value beside Icon & Show Text as a on Hover" },
  { id: 200, value: "Hide the Value & Show text beside Icon" },
  { id: 300, value: "Show only Icon & Text as on hover" },
  { id: 400, value: "Show Icon & Text beside the Icon" },
];

export const playModes = [
  { id: 100, name: "Live" },
  { id: 200, name: "PlayBack" },
];

export const customDeleteStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    // padding: "0%",
    backgroundColor: "#1A1D27",
    borderRadius: "8px",
    padding: "5px 5px",
  },
};

export const multiSelectStyle = {
  styles: {
    control: (st) => {
      return {
        ...st,
        borderColor: "#363945",
        paddingLeft: "7px",
      };
    },
    menu: (st) => {
      return {
        ...st,
        borderRadius: 5,
      };
    },
  },
  theme: (theme) => {
    return {
      ...theme,
      borderRadius: 10,
      borderColor: "black",
      colors: {
        ...theme.colors,
        primary25: "#7F868F",
        primary: "#363945",
        neutral0: "#363949",
        neutral10: "#2b2e39",
        neutral80: "white",
        dangerLight: "rgb(38,38,38)",
        danger: "white",
      },
    };
  },
};

export const timeZones = [
  { zone: "UTC", gmt: "(GMT+00:00)", name: "UTC (GMT+00:00)" },
  {
    zone: "America/Los_Angeles",
    gmt: "(GMT-08:00)",
    name: "Pacific/Los_Angeles (GMT-08:00)",
  },
  {
    zone: "America/Denver",
    gmt: "(GMT-07:00)",
    name: "America/Denver (GMT-07:00)",
  },
  {
    zone: "America/Chicago",
    gmt: "(GMT-06:00)",
    name: "America/Chicago (GMT-06:00)",
  },
  {
    zone: "America/New_ York",
    gmt: "(GMT-05:00)",
    name: "America/New_York (GMT-05:00)",
  },
  {
    zone: "America/Sao_Paulo",
    gmt: "(GMT-03:00)",
    name: "America/Sao_Paulo (GMT-03:00)",
  },
  {
    zone: "Atlantic/Cape_Verde",
    gmt: "(GMT-01:00)",
    name: "Atlantic/Cape_Verde (GMT-01:00)",
  },
  {
    zone: "Europe/London",
    gmt: "(GMT+00:00)",
    name: "Europe/London (GMT+00:00)",
  },
  {
    zone: "Europe/Paris",
    gmt: "(GMT+01:00)",
    name: "Europe/Paris (GMT+01:00)",
  },
  {
    zone: "Europe/Berlin",
    gmt: "(GMT+01:00)",
    name: "Europe/Berlin (GMT+01:00)",
  },
  {
    zone: "Europe/Moscow",
    gmt: "(GMT+03:00)",
    name: "Europe/Moscow (GMT+03:00)",
  },
  {
    zone: "Africa/Cairo",
    gmt: "(GMT+02:00)",
    name: "Africa/Cairo (GMT+02:00)",
  },
  { zone: "Asia/Dubai", gmt: "(GMT+04:00)", name: "Asia/Dubai (GMT+04:00)" },
  { zone: "Asia/Tehran", gmt: "(GMT+03:30)", name: "Asia/Tehran (GMT+03:30)" },
  {
    zone: "Asia/Karachi",
    gmt: "(GMT+05:00)",
    name: "Asia/Karachi (GMT+05:00)",
  },
  {
    zone: "Asia/Calcutta",
    gmt: "(GMT+05:30)",
    name: "Asia/Calcutta (GMT+05:30)",
  },
  {
    zone: "Asia/Beijing",
    gmt: "(GMT+08:00)",
    name: "Asia/Beijing (GMT+08:00)",
  },
  { zone: "Asia/Tokyo", gmt: "(GMT+09:00)", name: "Asia/Tokyo (GMT+09:00)" },
  {
    zone: "Australia/Sydney",
    gmt: "(GMT+11:00)",
    name: "Australia/Sydney (GMT+11:00)",
  },
  {
    zone: "Pacific/Auckland",
    gmt: "(GMT+12:00)",
    name: "Pacific/Auckland (GMT+12:00)",
  },
  { zone: "Fiji/Suva", gmt: "(GMT+12:00)", name: "Fiji/Suva (GMT+12:00)" },
  {
    zone: "America/Anchorage",
    gmt: "(GMT-09:00)",
    name: "America/Anchorage (GMT-09:00)",
  },
  {
    zone: "Pacific/Honolulu",
    gmt: "(GMT-10:00)",
    name: "Pacific/Honolulu (GMT-10:00)",
  },
];

export const formatAlarmValue = (
  alarmType,
  sensorValue,
  flowdirection,
  sensorType
) => {
  switch (alarmType) {
    case "sensor":
      if (sensorType === "Number") return parseFloat(sensorValue?.toFixed(2));
      else return sensorValue;
    case "geofence":
      return (
        <div className={`flex gap-1 ${flowdirection}`}>
          {sensorValue?.split(",").map((coordinate, index) => (
            <div key={index}>
              {index === 0 ? "lat" : "lng"}&nbsp;:&nbsp;
              {parseFloat(coordinate).toFixed(2)}
            </div>
          ))}
        </div>
      );

    default:
      return "";
  }
};

export const mapConfig = {
  center: {
    lat: 0,
    lng: 0,
  },
  googleMapsApiKey: "AIzaSyD229JvSAtxIEF5CEUDXInDphBRpTq7jj8",
  zoom: 11,
  fullscreenControl: false,
  libraries: ["drawing", "places"],
  styleLight: [
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#c9edc5",
        },
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f4f3f0",
        },
      ],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "landscape.natural.terrain",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#bcdfb8",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.sports_complex",
      elementType: "geometry",
      stylers: [
        {
          color: "#c8eec4",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          lightness: 100,
        },
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.text",
      stylers: [
        {
          weight: "1",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          lightness: "0",
        },
        {
          color: "#ffe492",
        },
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          weight: "2.53",
        },
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          weight: "0.50",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          visibility: "on",
        },
        {
          lightness: 700,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#7dcdcd",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#abd9ee",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
  ],
  styles: [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#A7AAB4" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit.station",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ],
};
export const CleanKey = (key) => key.trim().replace(/\s+/g, "_").toLowerCase();
